import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';

import {useLanguageDirection, useUI} from 'coreHooks';

import Flyout from 'brandComponents/Flyout';
import {EFlyoutDirections} from 'brandComponents/Flyout/IFlyout';

import FiltersRefinement from './FiltersRefinement/FiltersRefinement';
import FiltersRefinementActions from './FiltersRefinementActions';
import FiltersRefinementLoading from './FiltersRefinementLoading';
import {FiltersContextProvider} from './FlyoutFilterContext';
import messages from './messages';

import styles from './FlyoutFilters.module.scss';

const FlyoutFilters = () => {
	const intl = useIntl();
	const languageAttributes = useLanguageDirection();
	const searchConfig = useUI('searchConfig');
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const providerValue = useMemo(
		() => ({
			setIsLoading,
			searchConfig,
		}), [searchConfig],
	);

	return (
		<Flyout
			id="filters"
			flyoutClassName={styles['flyout-filters']}
			showCloseButton
			softLock
			contentClassName={styles['flyout-filters__content']}
			closeClassName={styles['flyout-filters__close']}
			direction={
				languageAttributes.direction === 'rtl'
					? EFlyoutDirections.RIGHT_TO_LEFT
					: EFlyoutDirections.LEFT_TO_RIGHT
			}
			closeButtonText={intl.formatMessage(messages.close)}
			className={styles['filters']}
		>
			<FiltersContextProvider value={providerValue}>
				<FiltersRefinement />
				<FiltersRefinementActions />
				{isLoading && <FiltersRefinementLoading />}
			</FiltersContextProvider>
		</Flyout>
	);
};

export default FlyoutFilters;
